import { useCallback, useState } from "react";

import { PageLayout, PageTitle } from "../components/AppLayout/components/Content/components";
import { DocIndex } from "./components/DocIndex";
import type { ViewDetail } from "./types/ViewDetail";

export const Documentation = () => {
    const [view, setView] = useState<ViewDetail>();

    const onIndexChanges = useCallback(
        (nextView: ViewDetail) => {
            setView(nextView);
        },
        [setView],
    );

    return (
        <PageLayout>
            <DocIndex onClick={onIndexChanges} />
            {view && (
                <div>
                    <PageTitle translationKey={view.title} />
                    {view.component}
                </div>
            )}
        </PageLayout>
    );
};
